<svg width="12" height="6" viewBox="0 0 12 6" xmlns="http://www.w3.org/2000/svg">
  <path d="M6 0L12 6L0 6L6 0Z" />
</svg>
